import React from "react";
import { CardControlsRestartButton } from "./card-controls-restart-button.component";
import { popupMenuOptions } from "../parent/data/popupMenuOptions";
import moment from "moment";

const CardControlsComplete = (props) => {

  const getContent = () => {
    if (props.travelExemptionResponse && (props.travelExemptionResponse.OldExemptionsExpired === false || 
        props.travelExemptionResponse.NewExemptionsAdded === false)
    ) {
      return (          
        <div className="my-5">
          <h2 className="bolder text-center">An Error Has Occurred.</h2>
          <div className="text-center" style={{ maxWidth: "570px", margin: "auto" }}>
            Please start over and add your travel exemption.
          </div>
        </div>
      );
    }
    switch (props.cardInfo.type)
    {
      case popupMenuOptions.valid.ResetPIN:
        return (
          <div className="my-5">
            <h2 className="bolder text-center">Your PIN has been reset.</h2>
            <h2 className="bolder text-center">Thank you.</h2>
          </div>
        );
      case popupMenuOptions.valid.ReplaceCard:
        return (
          <div className="my-5">
            <h2 className="bolder text-center">Your Card Replacement request has been received.</h2>
            <div className="text-center">You will receive your card in the mail within 7-10 business days.</div>
          </div>
        );
      case popupMenuOptions.other.EligibleTravelExemption:
        const endDate = moment(props.travelExemptionResponse.EndDate).format("MM/DD/YYYY");
        if (props.cardInfo.isCancellation === true) {
          return (          
          <div className="my-5">
            <h2 className="bolder text-center">Travel Exemption Cancellation Confirmed.</h2>
            <div className="text-center" style={{ maxWidth: "570px", margin: "auto" }}>
              Your travel exemption has been successfully cancelled.
            </div>
          </div>
        );
        }
        else {
          return (          
            <div className="my-5">
              <h2 className="bolder text-center">Travel Exemption Confirmed.</h2>
              <div className="text-center" style={{ maxWidth: "570px", margin: "auto" }}>
                Your travel exemption has been successfully submitted. Please note that your exemption is only valid in the countries selected
                and will end on {endDate}. A confirmation email has been sent to email address: {props.travelExemptionResponse.Email}
              </div>
            </div>
          );
        }
      default:
        return (
          <div className="my-5">
            <h2 className="bolder text-center">Your request has been submitted.</h2>
            <h2 className="bolder text-center">Thank you.</h2>
          </div>
        );
    }
  }

  return (
    <div className="m-5">
      {getContent()}
      <CardControlsRestartButton
        backToCards={props.backToCards}
        buttonText="Back to Cards"
        extraStyles={{ maxWidth: "370px", margin: "auto", backgroundColor: "#00558c" }}
      />
    </div>
  );
};

export default CardControlsComplete;



// WEBPACK FOOTER //
// ./src/components/card-controls/misc/card-controls-complete.component.js